import { IntlShape } from 'react-intl/src/types';

interface UnlockWalletExtraTextProps {
  intl: IntlShape;
}

export function UnlockWalletExtraText({ intl }: UnlockWalletExtraTextProps) {
  return null;
}
